module.exports = __webpack_public_path__ + "img/blog-3.5be32c90.jpg";